var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",class:{dark:_vm.dark}},[_c('div',{staticClass:"card-body",class:{'stacked' : _vm.stacked}},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }